import { get } from 'lodash';
import {
	IFT_OVER_LIMIT_ERROR_CODE,
	IFT_CHAIN_BUILD_ERROR_CODE,
	IFT_DIFFERENT_CURRENCY_ERROR_CODE,
	IFT_EXCEEDS_PREBOOKED_LIMIT_ERROR_CODE,
} from '../../config/ift';

export const hasError = (state) => !!state.rates.error;

export const isRatesApiInProgress = (state) => state.rates.isRatesApiInProgress;

export const getError = (state) => get(state, 'rates.error.response.error', '');

export const ratesErrorContentKey = (state) => {
	switch (get(getError(state), 'code', '')) {
		case IFT_OVER_LIMIT_ERROR_CODE:
			return 'overLimitErrorContent';
		case IFT_CHAIN_BUILD_ERROR_CODE:
		case IFT_DIFFERENT_CURRENCY_ERROR_CODE:
			return 'chainBuildOrDifferentCurrencyErrorContent';
		case IFT_EXCEEDS_PREBOOKED_LIMIT_ERROR_CODE:
			return 'exceedsPreBookedLimitErrorContent';
		default:
			return 'ratesFailedErrorContent';
	}
};
